import devicePixelRatio from './devicePixelRatio';
var defaultSizeList = [[80], [120], [150], [170], [200], [240], [260], [270], [300], [340], [360], [400], [460], [720], [1200], [2200]];

/**
 * get the best size of image
 * @param {number} width: expected width,
 * @param  {number} height: expected height
 */
function getSize(width, height, params) {
  var targetWidth = 0;
  var displayWidth = width || screen.width || 0;
  var displayHeight = height || 0;
  if (!displayWidth && !displayHeight) {
    return '';
  }
  targetWidth = Math.max(displayWidth, displayHeight);
  targetWidth *= devicePixelRatio;
  var sizeList = defaultSizeList;
  if (params.sizeList && Object.prototype.toString.call(params.sizeList) === '[object Array]' && params.sizeList.length > 0) {
    sizeList = params.sizeList;
  }
  var bestSize = sizeList.find(function (size) {
    return Math.min(size[0], size[1] || size[0]) >= targetWidth;
  });
  if (!bestSize) {
    bestSize = sizeList[sizeList.length - 1];
  }
  var bestSizeString = bestSize ? bestSize[0] + "x" + (bestSize[1] || bestSize[0]) : '';
  return bestSizeString;
}
export default getSize;